import type { ComponentProps, ForwardedRef } from 'react';
import React from 'react';
import type { CSS } from '@components-shared/src/stitches';
import { keyframes, styled } from '@components-shared/src/stitches';

export type SkeletonArgs = {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  css?: CSS;
};

/**
 * @deprecated Extend with styled Skeleton if possible
 */
export const DeprecatedDynamicSkeleton = React.memo(
  React.forwardRef(
    (
      {
        width,
        height,
        borderRadius,
        css,
        ...props
      }: ComponentProps<typeof Skeleton> & SkeletonArgs,
      forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
      return (
        <Skeleton ref={forwardedRef} css={{ width, height, borderRadius, ...css }} {...props} />
      );
    },
  ),
);

const pulse = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: '100%' },
});

export const LOADING_STYLES = {
  background: 'linear-gradient(135deg, #E7E7E7 0%, rgba(238, 238, 238, 0.37) 52.1%)',
  position: 'relative',
  overflow: 'hidden',

  '&::after': {
    animationName: `${pulse}`,
    animationDuration: '1000ms',
    animationDirection: 'alternate',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    backgroundColor: '$neutral100',
    borderRadius: 'inherit',
    bottom: 0,
    content: '""',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
};

export const Skeleton = styled('div', {
  ...LOADING_STYLES,
});
